"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createReducer(initialState, handlers) {
    return function reducer(state, action) {
        if (state === undefined) {
            state = initialState;
        }
        if (action && action.type && handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action);
        }
        else {
            return state;
        }
    };
}
exports.createReducer = createReducer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/utils/redux.js
// module id = 64
// module chunks = 0